import { Link } from "react-router-dom";
import { CheckCircle2, Sparkles } from "lucide-react";
import { useEffect, useRef } from "react";
import { useCart } from "../lib/CartContext";
import { usePirate } from "../lib/PirateContext";

/**
 * Legacy checkout-success page.
 * With Shopify, the confirmation happens on Shopify's own thank-you page.
 * This is a fallback if someone hits our /checkout/success URL directly.
 */
export default function CheckoutSuccess() {
    const { clear } = useCart();
    const { award } = usePirate();
    const done = useRef(false);

    useEffect(() => {
        if (done.current) return;
        done.current = true;
        clear();
        award("purchase");
    }, [clear, award]);

    return (
        <div
            className="max-w-3xl mx-auto px-5 lg:px-10 py-20"
            data-testid="checkout-success-page"
        >
            <div className="bounty-card p-10 lg:p-16 text-center relative">
                <div className="tape -top-3 left-12" />
                <div className="tape -top-3 right-12 rotate-[6deg]" />

                <CheckCircle2 size={64} className="mx-auto text-bounty" />
                <div className="font-hand text-3xl text-bounty mt-4">
                    tesoro consegnato
                </div>
                <h1
                    className="font-display text-6xl lg:text-7xl tracking-tight mt-2"
                    data-testid="success-heading"
                >
                    ORDINE CONFERMATO
                </h1>
                <p className="mt-4 text-ink/80">
                    Grazie, pirata! Riceverai una email di conferma da Shopify
                    a breve. Il tuo tesoro salperà presto verso di te.
                </p>
                <div className="mt-6 inline-flex items-center gap-2 px-4 py-2 border-2 border-ink bg-gold shadow-manga font-mono text-sm">
                    <Sparkles size={16} /> +500 XP · +1000 Berry guadagnati!
                </div>
                <div className="mt-8">
                    <Link
                        to="/figure"
                        className="btn-manga btn-manga-red inline-flex"
                    >
                        Continua a esplorare
                    </Link>
                </div>
            </div>
        </div>
    );
}
